export enum IdStatusProcessoSolicitacaoAtividade {
    Solicitada = 1,
    Executada = 2,
    Validada = 3,
    Emrevisao = 4,
    Cancelada = 9,
    PendenteAnaliseResposta = 5,
}
